import React from 'react';

const HistoricalStudies = () => {
  return (
    <div>
      HistoricalStudies
      HistoricalStudies
    </div>
  );
}

export default HistoricalStudies;
